import React from 'react';
import useGet from '../hook/use-get';
import { API } from '../helpers/constants';
import BusSchoolIcon from '../assets/bus-school-icon';
import MapIcon from '../assets/map-icon';
import MapMarkerIcon from '../assets/map-marker-icon';
import BuildingIcon from '../assets/building-icon';
import { SectionError } from './error';

const getTotalOverview = (data) => [
  { icon: <BusSchoolIcon />, label: 'Total Kendaraan', total: data?.['vehicle_total'] },
  { icon: <MapIcon />, label: 'Jenis Pelayanan', total: data?.['service_type'] },
  {
    icon: <MapMarkerIcon size={24} />,
    label: 'Rute Perjalanan',
    total: data?.['destination_rute']
  },
  { icon: <BuildingIcon />, label: 'Perusahaan Bus', total: data?.['bus_company'] }
];

const LabelAmount = () => {
  const { data, isFetching, isError, refetch } = useGet({
    queryKey: 'totalOverview',
    api: API.overview
  });
  const overviews = getTotalOverview(data);

  const renderContent = () => {
    if (isFetching) {
      return (
        <div className="grid grid-cols-1 m-auto md:grid-cols-2 lg:grid-cols-4 gap-6">
          {Array(4)
            .fill(0)
            .map(() => (
              <div className="w-full h-28 bg-gray-300 animate-pulse" />
            ))}
        </div>
      );
    }

    if (isError) {
      return (
        <div className="h-36 items-center justify-center flex border border-b rounded-lg">
          <SectionError refetch={refetch} />
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 m-auto md:grid-cols-2 lg:grid-cols-4 gap-6">
        {overviews?.map((item) => (
          <div className="space-y-1 m-auto">
            {item.icon}
            <h3 className="text-3xl font-medium text-left">{item.total}+</h3>
            <h3 className="text-2xl font-medium text-left">{item.label}</h3>
          </div>
        ))}
      </div>
    );
  };

  return renderContent();
};

export default LabelAmount;
